var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isContestsReportsPage
    ? _c(
        "div",
        { staticClass: "contest-picks-page" },
        [
          _vm.mobileBigAndBelow ? _c("contest-picks-header") : _vm._e(),
          _vm._v(" "),
          _c("contest-picks-body")
        ],
        1
      )
    : _c("router-view")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-043e3452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-043e3452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contests/ContestPicksPage.vue
// module id = null
// module chunks = 